module.exports = __webpack_public_path__ + "ffb462c5ca1c14cd96610d0eddf8dded.png";